import { render, staticRenderFns } from "./waybillAxis.vue?vue&type=template&id=ca33941e&scoped=true&"
import script from "./waybillAxis.vue?vue&type=script&lang=js&"
export * from "./waybillAxis.vue?vue&type=script&lang=js&"
import style0 from "./waybillAxis.vue?vue&type=style&index=0&id=ca33941e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca33941e",
  null
  
)

export default component.exports